import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PublicNavbar from "../components/PublicNavbar";
import Footer from "../components/Footer";

const colors = {
  primary: "#03f8d7",
  deepBg: "#0a0a0b",
  surface: "#1e293b",
  textMain: "#ffffff",
  textMuted: "#94a3b8",
};

function LandingPage() {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);

  const handleAppClick = (e) => {
    e.preventDefault();
    setShowPopup(true);
  };

  return (
    <div className="page-container">
      <style>
        {`
          .page-container {
            font-family: 'Inter', sans-serif;
            background-color: ${colors.deepBg};
            color: ${colors.textMain};
            min-height: 100vh;
            display: flex;
            flex-direction: column;
            overflow-x: hidden;
          }

          /* --- HERO --- */
          .hero-section {
            position: relative;
            padding: 120px 24px 80px;
            text-align: center;
            background-image: linear-gradient(180deg, rgba(10,10,11,0.92), rgba(10,10,11,0.8)), 
                              url('https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?q=80&w=2070');
            background-size: cover;
            background-position: center;
            min-height: 90vh;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
          }

          .section-tag {
            color: ${colors.primary};
            font-size: 11px;
            font-weight: 800;
            letter-spacing: 2px;
            text-transform: uppercase;
            margin-bottom: 20px;
            display: inline-block;
            border-bottom: 2px solid ${colors.primary};
            padding-bottom: 5px;
          }

          .hero-title {
            font-size: clamp(32px, 8vw, 64px);
            font-weight: 900;
            line-height: 1.1;
            margin-bottom: 25px;
            letter-spacing: -1.5px;
            max-width: 900px;
          }

          .hero-p {
             max-width: 600px; 
             margin: 0 auto 40px; 
             color: ${colors.textMuted}; 
             font-size: clamp(16px, 4vw, 18px); 
             line-height: 1.6;
             padding: 0 10px;
          }

          .cta-btn-premium {
            padding: 16px 40px;
            background-color: ${colors.primary};
            color: ${colors.deepBg};
            border: none;
            font-size: 15px;
            font-weight: 800;
            cursor: pointer;
            border-radius: 8px;
            transition: all 0.3s ease;
            box-shadow: 0 0 20px rgba(3, 248, 215, 0.3);
            text-transform: uppercase;
          }

          .cta-btn-premium:hover {
            transform: translateY(-2px);
            box-shadow: 0 0 30px rgba(3, 248, 215, 0.5);
          }

          /* --- OVERVIEW SECTION --- */
          .overview-section {
            padding: 80px 10%;
            background: ${colors.deepBg};
            display: grid;
            grid-template-columns: 1.2fr 0.8fr;
            gap: 50px;
            align-items: center;
          }

          .legitimacy-card {
            background: ${colors.surface};
            padding: 40px;
            border-radius: 24px;
            border: 1px solid rgba(3, 248, 215, 0.15);
            box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
          }

          /* --- HOW IT WORKS --- */
          .how-it-works {
            padding: 80px 10%;
            background: #0f172a;
            text-align: center;
          }

          .step-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
            gap: 30px;
            margin-top: 50px;
          }

          .step-card {
            background: ${colors.deepBg};
            padding: 40px 24px;
            border-radius: 20px;
            transition: 0.4s ease;
            border: 1px solid rgba(255,255,255,0.03);
            position: relative;
          }

          .step-card:hover { 
            transform: translateY(-10px); 
            border-color: ${colors.primary};
          }
          
          .step-num {
            position: absolute;
            top: -15px;
            left: 24px;
            background: ${colors.primary};
            color: ${colors.deepBg};
            width: 35px;
            height: 35px;
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 900;
          }

          /* --- APP SECTION --- */
          .app-section {
            padding: 60px 10% 40px;
            background: ${colors.deepBg};
            display: flex;
            justify-content: center;
          }

          .app-card {
            background: ${colors.surface};
            width: 100%;
            max-width: 900px;
            padding: 40px 20px;
            border-radius: 24px;
            text-align: center;
            border: 1px solid rgba(3, 248, 215, 0.1);
          }

          .badge-group {
            display: flex;
            gap: 15px;
            margin-top: 30px;
            flex-wrap: wrap;
            justify-content: center;
          }

          .app-badge {
            height: 42px;
            cursor: pointer;
            filter: grayscale(1) brightness(1.2);
            transition: 0.3s;
          }

          .app-badge:hover { 
            filter: grayscale(0) brightness(1);
          }

          /* --- CONTACT SECTION --- */
          .contact-section {
            padding: 0 10% 80px;
            background: ${colors.deepBg};
            display: flex;
            justify-content: center;
          }

          .contact-card {
            background: ${colors.surface};
            width: 100%;
            max-width: 900px;
            padding: 40px;
            border-radius: 24px;
            border: 1px solid rgba(3, 248, 215, 0.15);
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);
          }

          .contact-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
            gap: 30px;
            margin-top: 30px;
            text-align: left;
          }

          .contact-item h4 {
            color: ${colors.primary};
            font-size: 14px;
            font-weight: 800;
            text-transform: uppercase;
            margin-bottom: 8px;
            letter-spacing: 0.5px;
          }

          .contact-item p, .contact-item a {
            color: ${colors.textMain};
            font-size: 15px;
            line-height: 1.5;
            text-decoration: none;
          }

          .contact-item a:hover {
            color: ${colors.primary};
          }

          /* --- MOBILE RESPONSIVE FIXES --- */
          @media (max-width: 1024px) {
            .overview-section { grid-template-columns: 1fr; padding: 60px 8%; text-align: center; }
            .hero-section { padding-top: 100px; }
          }

          @media (max-width: 640px) {
            .hero-section { padding: 100px 16px 60px; }
            .hero-title { font-size: 32px; }
            .overview-section { padding: 40px 20px; }
            .legitimacy-card { padding: 24px; }
            .step-grid { gap: 40px; }
            .app-card { padding: 30px 16px; }
            .contact-card { padding: 30px 20px; }
            .contact-grid { grid-template-columns: 1fr; gap: 25px; text-align: center; }
          }
        `}
      </style>

      <PublicNavbar />

      <main>
        {/* --- HERO SECTION --- */}
        <header className="hero-section">
          <span className="section-tag">Global Fleet Intelligence</span>
          <h1 className="hero-title">
            Optimize, Dispatch & <br /> 
            <span style={{ color: colors.primary }}>Command Your</span> <br />
            Global Supply Chain
          </h1>
          <p className="hero-p">
            The unified dashboard for ocean freight logistics and commercial fleet management. 
            Connect with global shipping lanes through our secure cloud connection.
          </p>
          <button className="cta-btn-premium" onClick={() => navigate("/signup")}>
            Get Started In 2 Minutes →
          </button>
        </header>

        {/* --- CORPORATE OVERVIEW --- */}
        <section className="overview-section">
          <div className="overview-text">
            <span className="section-tag">Executive Overview</span>
            <h2 style={{ fontSize: "clamp(28px, 5vw, 40px)", fontWeight: 900, marginBottom: "20px" }}>Operational Integrity</h2>
            <p style={{ color: colors.textMuted, lineHeight: "1.7", fontSize: "16px", marginBottom: "15px" }}>
              Maritime Supply Suite (MSS) serves as a trusted software provider for modern maritime logistics. 
              Our suite simplifies commercial fleet tracking, offering authorized team members a 
              transparent interface for managing high-value assets. 
            </p>
            <p style={{ color: colors.textMuted, lineHeight: "1.7", fontSize: "16px" }}>
              Headquartered in the Hamburg maritime district, we bridge the gap between heavy cargo distribution 
              and real-time tracking systems. Our software ensures every tracked container and vessel is updated 
              according to international standards.
            </p>
          </div>

          <div className="legitimacy-card">
            <h3 style={{ fontSize: "18px", fontWeight: "800", marginBottom: "20px", color: colors.primary, textAlign: "left", width: "100%" }}>Protocol Certification</h3>
            <ul style={{ listStyle: "none", padding: 0, color: colors.textMuted, fontSize: "15px", textAlign: "left" }}>
              <li style={{ marginBottom: "15px", display: "flex", alignItems: "center", gap: "12px" }}>
                <span style={{ color: colors.primary }}>✔</span> Registered Corporate HQ
              </li>
              <li style={{ marginBottom: "15px", display: "flex", alignItems: "center", gap: "12px" }}>
                <span style={{ color: colors.primary }}>✔</span> 24/7 Technical Operations Support
              </li>
              <li style={{ marginBottom: "15px", display: "flex", alignItems: "center", gap: "12px" }}>
                <span style={{ color: colors.primary }}>✔</span> Secure Fleet Status Live Updates
              </li>
              <li style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <span style={{ color: colors.primary }}>✔</span> Compliant Freight Management Protocols
              </li>
            </ul>
          </div>
        </section>

        {/* --- HOW IT WORKS --- */}
        <section className="how-it-works">
          <span className="section-tag">System Architecture</span>
          <h2 style={{ fontSize: "clamp(28px, 5vw, 36px)", fontWeight: 900 }}>How the Suite Functions</h2>
          
          <div className="step-grid">
            <div className="step-card">
              <div className="step-num">01</div>
              <h3 style={{ color: colors.primary, marginBottom: "15px", fontSize: "18px", fontWeight: "800" }}>Account Creation</h3>
              <p style={{ color: colors.textMuted, fontSize: "14px", lineHeight: "1.6" }}>
                Authorized team members set up their company profile through our secure portal, 
                establishing a private login connection.
              </p>
            </div>
            <div className="step-card">
              <div className="step-num">02</div>
              <h3 style={{ color: colors.primary, marginBottom: "15px", fontSize: "18px", fontWeight: "800" }}>Cargo Integration</h3>
              <p style={{ color: colors.textMuted, fontSize: "14px", lineHeight: "1.6" }}>
                Logistics routes and technical cargo data are uploaded and matched 
                with sea routes for continuous live visibility.
              </p>
            </div>
            <div className="step-card">
              <div className="step-num">03</div>
              <h3 style={{ color: colors.primary, marginBottom: "15px", fontSize: "18px", fontWeight: "800" }}>Command Dispatch</h3>
              <p style={{ color: colors.textMuted, fontSize: "14px", lineHeight: "1.6" }}>
                Utilize the command dashboard to streamline delivery routes and 
                process heavy-duty assets smoothly through our system.
              </p>
            </div>
          </div>
        </section>

        {/* --- APP SECTION --- */}
        <section className="app-section">
          <div className="app-card">
            <span className="section-tag" style={{ marginBottom: "10px" }}>Remote Portal Access</span>
            <h2 style={{ fontSize: "28px", fontWeight: 900, marginBottom: "15px" }}>Mobile Dispatch Portal</h2>
            <p style={{ color: colors.textMuted, fontSize: "15px", maxWidth: "600px", margin: "0 auto" }}>
              Access your platform on the go. Secure login and automatic data caching 
              built for field operations personnel.
            </p>
            
            <div className="badge-group">
              <img 
                src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg" 
                alt="App Store" 
                className="app-badge" 
                onClick={handleAppClick}
              />
              <img 
                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" 
                alt="Google Play" 
                className="app-badge" 
                onClick={handleAppClick}
              />
            </div>
          </div>
        </section>

        {/* --- CONTACT & ADDRESS SECTION --- */}
        <section className="contact-section">
          <div className="contact-card">
            <span className="section-tag" style={{ marginBottom: "10px" }}>Corporate Information</span>
            <h2 style={{ fontSize: "28px", fontWeight: 900, marginBottom: "15px", textAlign: "center" }}>Connect With Us</h2>
            
            <div className="contact-grid">
              <div className="contact-item">
                <h4>Office Location</h4>
                <p>
                  Maritime Supply Suite<br />
                  Platz 13, 20366<br />
                  Hamburg, Germany
                </p>
              </div>
              
              <div className="contact-item">
                <h4>Email Support</h4>
                <p>
                  <a href="mailto:support@maritimesupplysuite.shop">
                    support@maritimesupplysuite.shop
                  </a>
                </p>
              </div>

              <div className="contact-item">
                <h4>Helpline & Sales</h4>
                <p>
                  Phone: <a href="tel:+4915731607647">+49 157 31607647</a>
                </p>
              </div>

              <div className="contact-item">
                <h4>Instant Assistance</h4>
                <p>
                  WhatsApp: <a href="https://wa.me/4915731607647" target="_blank" rel="noopener noreferrer" style={{ color: colors.primary, fontWeight: "bold" }}>
                    Chat Live Now ↗
                  </a>
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* --- NOTIFICATION POPUP --- */}
      {showPopup && (
        <div 
          style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.9)", zIndex: 20000, display: "flex", alignItems: "center", justifyContent: "center", padding: "20px", backdropFilter: "blur(8px)" }} 
          onClick={() => setShowPopup(false)}
        >
          <div 
            style={{ background: colors.surface, padding: "40px 24px", borderRadius: "24px", textAlign: "center", maxWidth: "400px", border: `1px solid ${colors.primary}` }} 
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ fontSize: "50px", marginBottom: "15px" }}>📡</div>
            <h3 style={{ fontSize: "22px", fontWeight: 900, marginBottom: "10px" }}>Connection Paused</h3>
            <p style={{ color: colors.textMuted, fontSize: "15px", lineHeight: "1.6", marginBottom: "25px" }}>
              Mobile applications are currently undergoing a standard security and framework update. 
              Service will be fully online shortly.
            </p>
            <button 
              className="cta-btn-premium" 
              style={{ width: "100%" }} 
              onClick={() => setShowPopup(false)}
            >
              Acknowledge
            </button>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}

export default LandingPage;